import React, { FunctionComponent } from 'react';

import styles from './LineSeparator.module.scss';

const LineSeparator: FunctionComponent = () => {
  return <div className={styles.separator} />;
};

export default LineSeparator;
